<template>
  <form class="ipo-filters" @submit.prevent="$emit('submit')">
    <label class="ipo-field">
      <span>Empresa o ticker</span>
      <input
        type="search"
        :value="query"
        maxlength="100"
        placeholder="Ej.: Acme o ACME"
        @input="$emit('update:query', $event.target.value)"
      />
    </label>

    <label class="ipo-field">
      <span>País</span>
      <select :value="country" @change="$emit('update:country', $event.target.value)">
        <option v-for="option in countryOptions" :key="option.key" :value="option.key">
          {{ option.label }}
        </option>
      </select>
    </label>

    <div class="ipo-filters__actions">
      <button class="ipo-button ipo-button--secondary" type="button" :disabled="loading" @click="$emit('reset')">
        Limpiar
      </button>
      <button class="ipo-button ipo-button--primary" type="submit" :disabled="loading">
        {{ loading ? 'Buscando…' : 'Buscar' }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'UpcomingIposFilters',
  props: {
    query: { type: String, default: '' },
    country: { type: String, default: 'all' },
    countryOptions: { type: Array, required: true },
    loading: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.ipo-filters { display: grid; grid-template-columns: minmax(180px, 1fr) minmax(190px, .7fr) auto; gap: 12px; align-items: end; }
.ipo-field { display: grid; gap: 7px; color: var(--modern-muted); font-size: 12px; font-weight: 700; }
.ipo-field input, .ipo-field select { width: 100%; height: 42px; box-sizing: border-box; padding: 0 12px; border: 1px solid var(--modern-border); border-radius: 10px; outline: none; background: var(--modern-bg); color: var(--modern-text); font: inherit; font-size: 13px; }
.ipo-field input:focus, .ipo-field select:focus { border-color: var(--modern-accent); box-shadow: 0 0 0 3px var(--modern-accent-soft); }
.ipo-filters__actions { display: flex; gap: 8px; }
.ipo-button { display: inline-flex; align-items: center; justify-content: center; min-height: 42px; box-sizing: border-box; padding: 0 15px; border: 1px solid transparent; border-radius: 10px; cursor: pointer; font: inherit; font-size: 13px; font-weight: 700; }
.ipo-button:disabled { cursor: wait; opacity: .65; }
.ipo-button--primary { background: var(--modern-accent); color: #fff; }
.ipo-button--secondary { border-color: var(--modern-border); background: var(--modern-surface); color: var(--modern-text); }
.ipo-button:focus-visible { outline: 3px solid var(--modern-accent-soft); outline-offset: 2px; }
@media (max-width: 900px) {
  .ipo-filters { grid-template-columns: 1fr 1fr; }
  .ipo-filters__actions { grid-column: 1 / -1; justify-content: flex-end; }
}
@media (max-width: 560px) {
  .ipo-filters { grid-template-columns: 1fr; }
  .ipo-filters__actions { grid-column: auto; }
  .ipo-filters__actions .ipo-button { flex: 1; }
}
</style>
